import { createAction, props } from '@ngrx/store';
import { PaymentCardsFlowType } from '@symphony-solo/domain/payment-cards/src/lib/enums/payment-cards-flow-type.enum';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { WebsitePageNamesEnum } from '../enums';

export enum LoyaltyWebsiteActionTypes {
  OpenWebsitePage = '[LoyaltyWebsite] OpenWebsitePage',
  OpenWebsitePageError = '[LoyaltyWebsite] OpenWebsitePageError',
  OpenWebsitePageSuccess = '[LoyaltyWebsite] OpenWebsitePageSuccess',
  OpenClickAndCollectWebsite = '[LoyaltyWebsite] OpenClickAndCollectWebsite',
  NotClickAndCollectPermission = '[LoyaltyWebsite] NotClickAndCollectPermission',
  OpenPublicWebsitePage = '[LoyaltyWebsite] OpenPublicWebsitePage',
  OpenAddCardPage = '[LoyaltyWebsite] OpenAddCardPage',
  PageOpened = '[LoyaltyWebsite] PageOpened',
}

export const openWebsitePageAction = createAction(LoyaltyWebsiteActionTypes.OpenWebsitePage, props<{ pageName: WebsitePageNamesEnum }>());

export const openWebsiteSuccessAction = createAction(
  LoyaltyWebsiteActionTypes.OpenWebsitePageSuccess,
  props<{ pageName: WebsitePageNamesEnum }>()
);
export const openWebsitePageErrorAction = createAction(
  LoyaltyWebsiteActionTypes.OpenWebsitePageError,
  props<{ failure: AppStateFailure }>()
);
export const openClickeAndCollectWebsiteAction = createAction(LoyaltyWebsiteActionTypes.OpenClickAndCollectWebsite);
export const noClickAndCollectPermissionAction = createAction(LoyaltyWebsiteActionTypes.NotClickAndCollectPermission);
export const openAddCardAction = createAction(LoyaltyWebsiteActionTypes.OpenAddCardPage, props<{ flow: PaymentCardsFlowType }>());

export const openPublicWebsitePageAction = createAction(
  LoyaltyWebsiteActionTypes.OpenPublicWebsitePage,
  props<{ pageName: WebsitePageNamesEnum }>()
);

export const pageOpenedAction = createAction(LoyaltyWebsiteActionTypes.PageOpened);
